import { t } from "i18next";
import { cloneDeep } from "lodash";
import { Loading } from "@qjumpers/common-ui";
import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useHistory } from "react-router";
import { useRecoilValue } from "recoil";
import moment from "moment";
import { documentInViewState } from "../../recoil/agreementdocuments/atom";
import { loadDocumentById, signDocumentSection, updateDocumentStatus } from "../../requests/agreementdocuments";
import { isInteractivePdfDocument, isIR330Document, isKS10Document, isKS2Document, isDriverConsentDocument, isJoinAUnionDocument } from "../../utils/documentsHelper";
import DynamicSections from "./DynamicSections";
import StaticFiles from "./StaticFiles";
import IR330C from "../InteractivePdf/IR330C/IR330C";
import KS2 from "../InteractivePdf/KS2/KS2";
import KS10 from "../InteractivePdf/KS10/KS10";
import DriverConsent from "../InteractivePdf/DriverConsent/DriverConsent";
import JoinUnion from "../InteractivePdf/JoinUnion/JoinUnion";
import TaxDeductionsDocumentFactory from "./TaxDeductionDocumentsFactory";

const Preview = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [sectionWithSigned, setSectionWithSigned] = useState([]);
  const [documentSections, setDocumentSections] = useState();
  const [isSubmit, setIsSubmit] = useState(false);
  const history = useHistory();

  const document = useRecoilValue(documentInViewState);

  // The document comes from Recoil state set by the documents list, so it is lost on a page refresh.
  const hasDocumentInView = Boolean(document?.document?.id);

  useEffect(() => {
    if (!hasDocumentInView) {
      history.replace("/applications");
      return undefined;
    }
    localStorage.removeItem("allSectionsSigned");
    loadDocumentById(document.candidateId, document.jobDetails.jobId, document.document.id).then((result) => {
      if (result.data) {
        setDocumentSections(result.data);
        setIsLoading(false);
      }
    });
    return () => {
      if (!document.document.isDocumentSingReqested) {
        loadDocumentById(document.candidateId, document.jobDetails.jobId, document.document.id).then((result) => {
          let sectionTobeSigned = result.data.filter(e => e.isSectionSignatureRequired === true);
          let sectionsSigned = result.data.filter(e => e.sectionSignedHtml !== null);
          if (sectionsSigned.length === sectionTobeSigned.length) {
            localStorage.setItem("allSectionsSigned", true);
            updateStates();
          }
        });
      }
    }
  }, []);

  const completeSectionSignature = (sectionid, trimmedDataURL) => {
    return new Promise((resolve, reject) => {
      let currentTimeStamp = moment().format("DD MMMM YYYY hh:mm:ss A");
      const data = {
        candidateId: document.candidateId,
        jobId: document.jobDetails.jobId,
        isTouchSignatureUI: trimmedDataURL !== "" ? true : false,
        signatureContent: trimmedDataURL !== "" ? trimmedDataURL : null,
        currentTimeStamp: currentTimeStamp,
      };
      signDocumentSection(data, sectionid).then((response) => {
        let signeHtmlContent = response.data.signedHtml?.replace(
          /<!-- pagebreak -->/g,
          "<br /><br />--------------------------------------------------------------------------Page Break--------------------------------------------------------------------------"
        );
        let sectionLevelSignatureFilled = {
          // sectionId: sectionId,
          sectionHtml: signeHtmlContent,
        };
        let newSectionWithSigned = cloneDeep(sectionWithSigned);
        newSectionWithSigned.push(sectionLevelSignatureFilled);
        setSectionWithSigned(newSectionWithSigned);
        loadDocumentById(document.candidateId, document.jobDetails.jobId, document.document.id).then((result) => {
          if (result.data) {
            setDocumentSections(result.data);
            return resolve();
          } else {
            reject();
          }
        });
      });
    });
  };

  const updateStates = (data, trimmedDataURL="") => {
    setIsSubmit(true);
    return new Promise((resolve, reject) => {
      const interactivePdfProperties = TaxDeductionsDocumentFactory(data);
      
      const base64sign = trimmedDataURL !== "" ? trimmedDataURL?.slice(22) : trimmedDataURL;
      let currentTimeStamp = moment().format("DD MMMM YYYY hh:mm:ss A");
      const dataObj = {
        organisationId: document.jobDetails.organisationId,
        updateToStatus: 3,
        candidateId: document.candidateId,
        jobId: document.jobDetails.jobId,
        isTouchSignatureUI: trimmedDataURL !== "" ? true : false,
        signatureContent: interactivePdfProperties !== null ? interactivePdfProperties.signatureContent : base64sign,
        currentTimeStamp: currentTimeStamp,
        isDefaultInterActivePdf: document.document.isDefaultInterActivePdf,
        interactivePdfProperties,
        documentName: document.document.name,
      };
      
      if (document.document.status !== 3 && document.status === 2 && document.status !== 0) {
        updateDocumentStatus(dataObj, document.document.id).then((response) => {
          if (response.data && response.data.statusCode === 417 && response.data.message) {
            resolve({ alert: true });
          } else {
            resolve({ alert: false });
          }
        });
      } else {
        resolve();
      }
      setIsSubmit(false);
    });
  };

  const redirectToList = () => {
    if (!document.document.isDocumentSingReqested && documentSections.length > 0) {
      loadDocumentById(document.candidateId, document.jobDetails.jobId, document.document.id).then((result) => {
        if (result.data) {
          let sectionTobeSigned = result.data.filter((e) => e.isSectionSignatureRequired === true);
          let sectionsSigned = result.data.filter((e) => e.sectionSignedHtml !== null);
          if (sectionsSigned.length === sectionTobeSigned.length) {
            localStorage.setItem("allSectionsSigned", true);
          }
          history.push(`/application/reviewdocument/${document.applicationId}`);
        }
      });
    } else {
      history.push(`/application/reviewdocument/${document.applicationId}`);
    }
  };

  if (!hasDocumentInView || isLoading) {
    return <Loading className="loading-component"></Loading>;
  }
  const isDocumentSignedCompletely = documentSections?.every((section) => section.sectionSignedHtml !== null);

  if (isInteractivePdfDocument(document.document.name) && document.document.status < 3 ) {
    return (
      <div>
          <div className="row">
            <div className="col-xs-12 col-sm-8 col-md-9" style={{ paddingTop: "1px", fontSize: "22px", color: "brown" }}>
              {document.document.name}
            </div>
            <div className="col-xs-12 col-sm-4 col-md-3">
              <Button 
                variant="outline-secondary"
                disabled={isSubmit}
                onClick={redirectToList}
                style={{ width: "165px", border: "1px solid #DDD", padding: "10px" }}>
                { t("Action.Back") }
              </Button>
            </div>
          </div>
          { isIR330Document(document.document.name) && <IR330C submit={updateStates} redirectToList={redirectToList} /> }
          { isKS2Document(document.document.name) && <KS2 submit={updateStates} redirectToList={redirectToList}/> }
          { isKS10Document(document.document.name) && <KS10 submit={updateStates} redirectToList={redirectToList}/> }
          { isDriverConsentDocument(document.document.name) && <DriverConsent submit={updateStates} redirectToList={redirectToList}/> }
          { isJoinAUnionDocument(document.document.name) && <JoinUnion submit={updateStates} redirectToList={redirectToList}/> }
        </div>
    )
    
  } else if (!isDocumentSignedCompletely && document.document.status < 3) {
    return (
      <DynamicSections documentSections={documentSections} sectionWithSigned={sectionWithSigned} document={document} redirectToList={redirectToList} completeSectionSignature={completeSectionSignature} updateStates={updateStates} />
    )
  } else {
    return (
      <StaticFiles documentSections={documentSections}  document={document} redirectToList={redirectToList} updateStates={updateStates} />
    )
  }
 
};

export default Preview;